export default __webpack_public_path__ + "static/media/pof-card-back.63adafa3.png";